// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nc-2";
export var chatLink = "_nc-0";
export var chatText = "_nc-1";